import { combineReducers } from 'redux';
import StatesReducer from './reducer_states';
import UsersReducer from './reducer_users';
import EmploymentsReducer from './reducer_employments';
import AssociateTypesReducer from './reducer_associate_types';
import { reducer as formReducer } from 'redux-form';

const rootReducer = combineReducers({
	employments: EmploymentsReducer, //<-- Employments
	states: StatesReducer, //<-- States
	users: UsersReducer, //<-- Users
	associateTypes: AssociateTypesReducer, //<-- AssociateTypes
	form: formReducer // <--- Form Reducer
});

export default rootReducer;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/